<template>
  <div id="container" ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->

    <div class="topContent">
      <div class="dh_wz">
        <div class="dh_wz_qq"></div>
        <div class="dh_wz_tb"></div>
        <div class="dh_wz_wz">灾害预警</div>
      </div>
      <div class="dh_lb">
        <router-link :to="{path:'/gbzntyj'}"><div class="dh_lb_bt">项目总览</div></router-link>
        <router-link :to="{path:'/plant'}"><div class="dh_lb_bt">高标准农田</div></router-link>
           <!-- <router-link :to="{path:'/gbzntjs'}"><div class="dh_lb_bt">建设预览</div></router-link> -->
        <router-link :to="{ path: '/zhinengGG' }"
          ><div class="dh_lb_bt">智能灌溉</div></router-link
        >
        <router-link :to="{ path: '/binghai' }"
          ><div class="dh_lb_bt">病虫害管理</div></router-link
        >
        <!-- <router-link :to="{ path: '/plantmoxing' }"
          ><div class="dh_lb_bt">种植模型</div></router-link
        > -->
        <!-- <router-link :to="{ path: '/suyuan' }"><div class="dh_lb_bt">农业溯源</div></router-link> -->
        <!-- <router-link :to="{ path: '/qihouYj' }"
          ><div class="dh_lb_bt dh_lb_bt_cur">气候灾害预警</div></router-link
        > -->
      </div>
      <div class="titleRightImg">
        <router-link :to="{ path: '/' }" ><img src="../assets/img/gbzntyj/sy.png" class="return" /></router-link>
        <img  src="../assets/img/gbzntyj/fh.png" class="return"  @click="clickReturn" />
      </div>
    </div>
    <div class="content">
      <div class="left">
        <div class="leftBox1">
          <div class="title">气候监测实时数据</div>
          <div class="echartsBox"><leftBar1 :leftData1="state.leftData1" /></div>
        </div>
        <div class="leftBox2">
          <div class="title">土壤数据监测</div>
          <div class="echartsBox">
              <leftLine :leftData2="state.leftData2" />
          </div>
        </div>
        <div class="leftBox3">
          <div class="title">降水预测指数</div>
          <div class="echartsBox"><leftBar2 :leftData3="state.leftData3" /></div>
        </div>
      </div>
      <div class="center">
        <div class="centerBox1"><img src="../assets/img/gbzntyj/qixiang/qx.png" /></div>
        <div class="centerBox2"><centerLine /></div>
      </div>
      <div class="right">
        <div class="rightBox1">
          <div class="title">受灾害预警</div>
          <div class="rightContent1">
            <div class="rightContent1_tit">
              <div class="rightContent1_tit_item" :class="{rightContent1_tit_itemCur:state.rightData1Index==index}" v-for="(item,index) in state.rightData1" :key="index" @click="tabClick(index)">{{item.name}}</div>
            </div>
            <div class="rightContent1_con">
              <div class="rightContent1_con_item" :class="{rightContent1_con_itemCur:item.value==1}" v-for="(item,index) in state.rightData1[state.rightData1Index].value" :key="index">
                <div class="time">{{item.time}}</div>
                <div class="value">{{item.value==0?'正常':state.rightData1[state.rightData1Index].name}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rightBox2">
          <div class="title">气象数据监测</div>
          <div class="rightContent1">
            <div class="rightContent1_item" v-for="(item,index) in state.rightData2" :key="index">
              <img :src="item.icon" />
              <div class="rightContent1_item_r">
                <span class="name">{{item.name}}</span>
                <span class="value">{{item.value}}<i>{{item.unit}}</i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/img/gbzntyj/qixiang/dbbg.png" class="bottom" />
    
  </div>
   <div class="footer">本产品由来村网提供技术支持</div>
</template>

<script setup>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

import leftBar1 from '../components/QihouYj/leftBar1'
import leftBar2 from '../components/QihouYj/leftBar2'
import leftLine from '../components/QihouYj/leftLine'
import centerLine from '../components/QihouYj/centerLine.vue'
const router = useRouter();
const state = reactive({
  leftData1:[
    ['土壤检测', '空气检测', '光照检测', '风速检测'],
    [70, 30, 100, 10]
  ],
  leftData3:[
    ["3/21", "3/22", "3/23", "3/24","3/25", "3/26", "3/27", "3/28"],
    [5.6, 8.9, 6, 5.8,5.6, 8.9, 6, 5.8]
  ],
  leftData2:[
    ["3/21", "3/22", "3/23", "3/24","3/25", "3/26", "3/27", "3/28"],
    [20, 28, 19, 26, 36, 35, 25,20],
    [ 86, 35, 25,20, 58, 19, 56, 86]
  ],
  rightData1:[
    {
      name:'大风',
      value:[
        {time:"2024.3.15",value:0},{time:"2024.3.16",value:1},{time:"2024.3.17",value:0},
        {time:"2024.3.18",value:1},{time:"2024.3.19",value:0},{time:"2024.3.20",value:0},
        {time:"2024.3.21",value:0},{time:"2024.3.22",value:0},{time:"2024.3.23",value:1},
      ]
    },
    {name:'高温',value:[
        {time:"2024.3.15",value:0},{time:"2024.3.16",value:0},{time:"2024.3.17",value:0},
        {time:"2024.3.18",value:1},{time:"2024.3.19",value:0},{time:"2024.3.20",value:0},
        {time:"2024.3.21",value:0},{time:"2024.3.22",value:0},{time:"2024.3.23",value:0},
      ]},
    {name:'冰雹',value:[
        {time:"2024.3.15",value:0},{time:"2024.3.16",value:0},{time:"2024.3.17",value:0},
        {time:"2024.3.18",value:1},{time:"2024.3.19",value:0},{time:"2024.3.20",value:0},
        {time:"2024.3.21",value:0},{time:"2024.3.22",value:0},{time:"2024.3.23",value:0},
      ]},
    {name:'干旱',value:[
        {time:"2024.3.15",value:0},{time:"2024.3.16",value:0},{time:"2024.3.17",value:0},
        {time:"2024.3.18",value:0},{time:"2024.3.19",value:1},{time:"2024.3.20",value:0},
        {time:"2024.3.21",value:0},{time:"2024.3.22",value:0},{time:"2024.3.23",value:0},
      ]}
  ],
  rightData1Index:0,
  rightData2:[
    {name:"风速",value:10,unit:"m/s",icon:require('@/assets/img/gbzntyj/qixiang/fs.png')},
    {name:"风向",value:'东南',unit:"",icon:require('@/assets/img/gbzntyj/qixiang/fx.png')},
    {name:"雨量",value:10,unit:"mm",icon:require('@/assets/img/gbzntyj/qixiang/dqy.png')},
    {name:"温度",value:'26',unit:"",icon:require('@/assets/img/gbzntyj/qixiang/wdsd.png')},
    {name:"湿度",value:10,unit:"%",icon:require('@/assets/img/gbzntyj/qixiang/wdsd.png')},
    // {name:"光照",value:'1258',unit:"Lux",icon:require('@/assets/img/gbzntyj/qixiang/fx.png')},
  ]
});

// 在 onMounted 中初始化地图
onMounted(() => {
  
});
function tabClick(index){
  state.rightData1Index = index
}
// 返回上一页
function clickReturn() {
  router.go(-1);
}

onUnmounted(() => {});
onBeforeUnmount(() => {
  // clearInterval(timer.value);
});


</script>
<style lang="less" scoped>
.footer{
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: #fff;
    text-align: center;
    font-size: 14px;
    position: fixed;
    bottom: 30px;
    left: 0;
    z-index: 10000;
    font-weight: bold;
    }
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .el-tabs__item {
  width: 102px;
  height: 72px;
  padding: 0;
  // border: 1px solid #1a6266;
  display: flex;
  justify-content: center;

  align-items: self-start;
  position: relative;
  margin: 0 10px;
  flex-shrink: 0;
  box-sizing: border-box;
  color: #fff;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before,
::v-deep .el-tabs__item::after {
  content: " ";
  background: #21fcff;
  width: 2px;
  height: 12px;
  position: absolute;
  top: 12px;
  background: url("../assets/img/plantmoxing/xz.png") no-repeat top center;
  background-size: 100% 100%;
}
::v-deep .el-tabs__item::before {
  left: -1px;
}
::v-deep .el-tabs__item::after {
  right: -1px;
}
::v-deep .el-tabs__nav {
  display: flex;
}
::v-deep .el-tabs__nav-wrap::after {
  display: none;
}
::v-deep .el-tabs__active-bar {
  width: 100%;
  background-color: #21fcff;
}
::v-deep .is-active {
  color: #a1c81f;
}
::v-deep .el-tabs__nav-prev {
  position: absolute;
  cursor: pointer;
  background: url("../assets/img/plantmoxing/zjt.png") no-repeat top center;
  background-size: 100% 100%;
  width: 18px;
  height: 23px;
  left: 1px;
  top: 20px;

  color: transparent; /* 文字颜色透明 */
}

.mainBox {
  width: 100%;
  height: 100vh;
  position: absolute;
  position: absolute;
  background: url("../assets/img/gbzntyj/qixiang/bj.jpg") no-repeat top center;
  background-size: 100% 100%;
  .dh_wz {
    width: 170px;
    height: 47px;
    position: absolute;
    left: 3%;
    top: 20%;
    background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
    background-size: 100% 100%;

    .dh_wz_qq {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      position: absolute;
      top: 6px;
      left: 7px;
      border: 1px solid #ffc600; /* 添加一个黑色的边框 */
    animation: guangying 2s linear infinite;
    }
    .dh_wz_tb {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 15px;
        top: 14px;
        background: url("../assets/img/gbzntyj/nt.png") no-repeat top center;
        background-size: 100% 100%;
        animation: topIcon 2s linear infinite;
      }
    .dh_wz_wz {
      width: 120px;
      height: 47px;
      line-height: 47px;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      text-align: center;
      position: absolute;
      right: 5%
    }
  }
  .topContent {
    width: 100%;
    height: 90px;
    position: relative;
    .titleRightImg {
      position: absolute;
      right: 0;
      top: 26%;
      .return {
        width: 77px;
        height: 32px;
        margin-right: 15px;
        cursor: pointer;
        position: relative;
        z-index: 999;
      }
    }
  }

  .dh_lb {
    // width: 900px;
    height: 45px;
    position: absolute;
    left: 23%;
    top: 20%;
    display: flex;
    flex-flow: row;
    a {
      text-decoration: none;
    }

    .dh_lb_bt {
      width: 124px;
      height: 43px;
      background: url("../assets/img/gbzntyj/yy.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #3bf4be;
      transition: all 0.5s ease-out;
    }
    .dh_lb_bt:hover,
    .dh_lb_bt_cur {
      width: 124px;
      height: 43px;
      cursor: pointer;
      background: url("../assets/img/gbzntyj/xz.png") no-repeat top center;
      background-size: 100% 100%;
      flex: 1;
      margin: 0 5px;
      font-family: MicrosoftYaHei;
      font-size: 16px;
      line-height: 43px;
      text-align: center;
      color: #fff;
    }
  }

  .content{
    width: 100%;
    height: calc(100% - 90px);
    display: flex;
    padding: 0 30px;
    box-sizing: border-box;
    .left{
      width: 476px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .leftBox1{
        width: 100%;
        height: 33%;
        display: flex;
        flex-direction: column;
      }
      .leftBox2{
        width: 100%;
        height: 30%;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      }
      .leftBox3{
        width: 100%;
        flex: 1;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
      }
    }
    .right{
      width: 476px;
      height: 100%;
      display: flex;
      flex-direction: column;
      .rightBox1{
        width: 100%;
        height: 33%;
        display: flex;
        flex-direction: column;
        .rightContent1{
          width: 1005;
          flex: 1;
          padding: 14px 20px;
          display: flex;
          flex-direction: column;
          .rightContent1_tit{
            width: 100%;
            height: 28px;
            display: flex;
            justify-content: space-between;
            .rightContent1_tit_item{
              width: 71px;
              height: 28px;
              background: url("../assets/img/gbzntyj/qixiang/wxz.png") no-repeat;
              text-align: center;
              line-height: 34px;
              color: #fff;
              font-size: 14px;
              cursor: pointer;
              // margin: 0 20px;
            }
            .rightContent1_tit_itemCur{
              color: #00F5E1;
              background: url("../assets/img/gbzntyj/qixiang/xz.png") no-repeat;
            }
          }
          .rightContent1_con{
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-content: space-between;
            flex-wrap: wrap;
            padding: 16px 10px;
            .rightContent1_con_item{
              width: 103px;
              font-size: 14px;
              .value{
                width: 100%;
                height: 27px;
                background: url('../assets/img/gbzntyj/qixiang/ls.png') no-repeat;
                text-align: center;
                line-height: 30px;
                color: #00F5E1;
                font-weight: bold;
              }
              .time{
                color: #fff;
                text-align: left;
                position: relative;
                padding-left: 15px;
                line-height: 26px;
              }
              .time::before{
                content: '';
                width: 6px;
                height: 6px;
                background:#00F5E1 ;
                position: absolute;
                left: 0;
                top: 10px;
              }
              
            }
            .rightContent1_con_itemCur{
              .value{
                background: url('../assets/img/gbzntyj/qixiang/hs.png') no-repeat;
                color: #F0C85C;
              }
              .time::before{
                background:#F0C85C ;
              }
              
            }
          }
        }
      }
      .rightBox2{
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightContent1{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 30px 0 50px;
          .rightContent1_item{
            width: 331px;
            height: 90px;
            padding: 0 36px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: url("../assets/img/gbzntyj/qixiang/jx.png") no-repeat;
            img{
              width: 35px;
              height: 33px;
              margin-right: 60px;
            }
            .rightContent1_item_r{
              flex: 1;
              display: flex;
              justify-content: space-between;
              line-height: 90px;
              span{
                display: block;
              }
              .name{
                font-size: 18px;
                color: rgba(255,255,255,.8);
                margin-right: 30px;
              }
              .value{
                color: #10E6B7;
                font-size: 26px;
                font-weight: bold;
                i{
                  font-size: 16px;
                }
              }
            } 
          }
        }
      }
    }
    .center{
      flex: 1;
      .centerBox1{
        height: 40%;
        img{
          width: 100%;
          height: 479px;
        }
      }
      .centerBox2{
        width: 100%;
        height: 60%;
        // border: 1px solid;
      }
    }
  }
  .bottom{
    position: absolute;
    bottom: 0;
    width: 1911px;
    height: 30px;
    left: 50%;
    margin-left: -955px;
    z-index: 0;
  }
  .title{
    width: 452px;
    height: 50px;
    line-height: 50px;
    background: url("../assets/img/gbzntyj/qixiang/xbt.png") no-repeat left bottom;
    text-align: left;
    color: #fff;
    font-size: 18px;
    padding-left: 30px;
  }
  .echartsBox{
    width: 100%;
    flex: 1;
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
.contentLine {
  background: #1aa19e;
  position: absolute;
}
.contentLine1 {
  top: 1px;
  left: 0;
  width: 10%;
  height: 2px;
  /* 加上渐变效果，方可形成拖尾效果 */
  background: linear-gradient(90deg, transparent, #1aa19e);
  animation: animate1 4s linear infinite;
}
.contentLine2 {
  top: -100%;
  right: 0;
  width: 2px;
  height: 20%;
  background: linear-gradient(180deg, transparent, #1aa19e);
  animation: animate2 4s linear infinite;
  /* 注意要加上延时触发动画效果，这样线条才会依次触发 */
  animation-delay: 1s;
}
.contentLine3 {
  bottom: 1px;
  right: 0;
  width: 20%;
  background: linear-gradient(270deg, transparent, #1aa19e);
  animation: animate3 4s linear infinite;
  animation-delay: 2s;
}
.contentLine4 {
  bottom: -100%;
  left: 1px;
  width: 2px;
  height: 10%;
  background: linear-gradient(360deg, transparent, #1aa19e);
  animation: animate4 4s linear infinite;
  animation-delay: 3s;
}
/* 定义关键帧 */
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

@keyframes animate1 {
  0% {
    left: -50%;
  }

  50%,
  100% {
    left: 100%;
  }
}

@keyframes animate2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}
@keyframes animate3 {
  0% {
    right: -100%;
    height: 3px;
  }

  50%,
  100% {
    height: 2px;
    right: 100%;
  }
}
@keyframes animate4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
@keyframes topIcon {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(15deg);
    transform: scale(.9);
  }
  75% {
    transform: rotate(-15deg);
    // transform: scale(.9);
  }
   100% {
    transform: rotate(0);
  }
}
</style>
